import { render, staticRenderFns } from "./kitchenL.vue?vue&type=template&id=8a9c16e4&"
import script from "./kitchenL.vue?vue&type=script&lang=js&"
export * from "./kitchenL.vue?vue&type=script&lang=js&"
import style0 from "./kitchenL.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports